"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_ENTRYPOINT_ADDRESS = exports.UserOpWaitForTxHashMaxDurationIntervals = exports.UserOpReceiptMaxDurationIntervals = exports.UserOpWaitForTxHashIntervals = exports.UserOpReceiptIntervals = void 0;
const core_types_1 = require("@biconomy/core-types");
// eslint-disable-next-line no-unused-vars
exports.UserOpReceiptIntervals = {
    [core_types_1.ChainId.MAINNET]: 10000,
    [core_types_1.ChainId.GOERLI]: 2000,
    [core_types_1.ChainId.POLYGON_MUMBAI]: 2000,
    [core_types_1.ChainId.POLYGON_MAINNET]: 2000,
    [core_types_1.ChainId.BSC_TESTNET]: 2000,
    [core_types_1.ChainId.BSC_MAINNET]: 2000,
    [core_types_1.ChainId.POLYGON_ZKEVM_TESTNET]: 2000,
    [core_types_1.ChainId.POLYGON_ZKEVM_MAINNET]: 2000,
    [core_types_1.ChainId.ARBITRUM_GOERLI_TESTNET]: 2000,
    [core_types_1.ChainId.ARBITRUM_ONE_MAINNET]: 2000,
    [core_types_1.ChainId.ARBITRUM_NOVA_MAINNET]: 2000,
    [core_types_1.ChainId.OPTIMISM_MAINNET]: 2000,
    [core_types_1.ChainId.OPTIMISM_GOERLI_TESTNET]: 2000,
    [core_types_1.ChainId.AVALANCHE_MAINNET]: 2000,
    [core_types_1.ChainId.AVALANCHE_TESTNET]: 2000,
    [core_types_1.ChainId.MOONBEAM_MAINNET]: 2000,
    [core_types_1.ChainId.BASE_GOERLI_TESTNET]: 2000,
    [core_types_1.ChainId.BASE_MAINNET]: 2000,
    [core_types_1.ChainId.LINEA_TESTNET]: 2000,
    [core_types_1.ChainId.LINEA_MAINNET]: 2000,
    [core_types_1.ChainId.MANTLE_MAINNET]: 2000,
    [core_types_1.ChainId.MANTLE_TESTNET]: 2000,
    [core_types_1.ChainId.OPBNB_MAINNET]: 2000,
    [core_types_1.ChainId.OPBNB_TESTNET]: 2000,
    [core_types_1.ChainId.ASTAR_MAINNET]: 2000,
    [core_types_1.ChainId.ASTAR_TESTNET]: 2000,
    [core_types_1.ChainId.CHILIZ_MAINNET]: 2000,
    [core_types_1.ChainId.CHILIZ_TESTNET]: 2000,
    [core_types_1.ChainId.CORE_MAINNET]: 2000,
    [core_types_1.ChainId.CORE_TESTNET]: 2000,
    [core_types_1.ChainId.MANTA_PACIFIC_MAINNET]: 2000,
    [core_types_1.ChainId.MANTA_PACIFIC_TESTNET]: 2000,
    [core_types_1.ChainId.CAPX_TESTNET]: 2000,
};
// Note: Reduced by 1/10th.. can reduce more
exports.UserOpWaitForTxHashIntervals = {
    [core_types_1.ChainId.MAINNET]: 1000,
    [core_types_1.ChainId.GOERLI]: 500,
    [core_types_1.ChainId.POLYGON_MUMBAI]: 500,
    [core_types_1.ChainId.POLYGON_MAINNET]: 500,
    [core_types_1.ChainId.BSC_TESTNET]: 500,
    [core_types_1.ChainId.BSC_MAINNET]: 500,
    [core_types_1.ChainId.POLYGON_ZKEVM_TESTNET]: 500,
    [core_types_1.ChainId.POLYGON_ZKEVM_MAINNET]: 500,
    [core_types_1.ChainId.ARBITRUM_GOERLI_TESTNET]: 500,
    [core_types_1.ChainId.ARBITRUM_ONE_MAINNET]: 500,
    [core_types_1.ChainId.ARBITRUM_NOVA_MAINNET]: 500,
    [core_types_1.ChainId.OPTIMISM_MAINNET]: 500,
    [core_types_1.ChainId.OPTIMISM_GOERLI_TESTNET]: 500,
    [core_types_1.ChainId.AVALANCHE_MAINNET]: 500,
    [core_types_1.ChainId.AVALANCHE_TESTNET]: 500,
    [core_types_1.ChainId.MOONBEAM_MAINNET]: 500,
    [core_types_1.ChainId.BASE_GOERLI_TESTNET]: 500,
    [core_types_1.ChainId.BASE_MAINNET]: 500,
    [core_types_1.ChainId.LINEA_TESTNET]: 500,
    [core_types_1.ChainId.LINEA_MAINNET]: 500,
    [core_types_1.ChainId.MANTLE_MAINNET]: 500,
    [core_types_1.ChainId.MANTLE_TESTNET]: 500,
    [core_types_1.ChainId.OPBNB_MAINNET]: 500,
    [core_types_1.ChainId.OPBNB_TESTNET]: 500,
    [core_types_1.ChainId.ASTAR_MAINNET]: 500,
    [core_types_1.ChainId.ASTAR_TESTNET]: 500,
    [core_types_1.ChainId.CHILIZ_MAINNET]: 500,
    [core_types_1.ChainId.CHILIZ_TESTNET]: 500,
    [core_types_1.ChainId.CORE_MAINNET]: 500,
    [core_types_1.ChainId.CORE_TESTNET]: 500,
    [core_types_1.ChainId.MANTA_PACIFIC_MAINNET]: 500,
    [core_types_1.ChainId.MANTA_PACIFIC_TESTNET]: 500,
    [core_types_1.ChainId.CAPX_TESTNET]: 500,
};
exports.UserOpReceiptMaxDurationIntervals = {
    [core_types_1.ChainId.MAINNET]: 300000,
    [core_types_1.ChainId.GOERLI]: 50000,
    [core_types_1.ChainId.POLYGON_MUMBAI]: 50000,
    [core_types_1.ChainId.POLYGON_MAINNET]: 60000,
    [core_types_1.ChainId.BSC_TESTNET]: 50000,
    [core_types_1.ChainId.BSC_MAINNET]: 50000,
    [core_types_1.ChainId.POLYGON_ZKEVM_TESTNET]: 40000,
    [core_types_1.ChainId.POLYGON_ZKEVM_MAINNET]: 40000,
    [core_types_1.ChainId.ARBITRUM_GOERLI_TESTNET]: 50000,
    [core_types_1.ChainId.ARBITRUM_ONE_MAINNET]: 50000,
    [core_types_1.ChainId.ARBITRUM_NOVA_MAINNET]: 30000,
    [core_types_1.ChainId.OPTIMISM_MAINNET]: 40000,
    [core_types_1.ChainId.OPTIMISM_GOERLI_TESTNET]: 40000,
    [core_types_1.ChainId.AVALANCHE_MAINNET]: 40000,
    [core_types_1.ChainId.AVALANCHE_TESTNET]: 40000,
    [core_types_1.ChainId.MOONBEAM_MAINNET]: 40000,
    [core_types_1.ChainId.BASE_GOERLI_TESTNET]: 40000,
    [core_types_1.ChainId.BASE_MAINNET]: 40000,
    [core_types_1.ChainId.LINEA_TESTNET]: 50000,
    [core_types_1.ChainId.LINEA_MAINNET]: 50000,
    [core_types_1.ChainId.MANTLE_MAINNET]: 40000,
    [core_types_1.ChainId.MANTLE_TESTNET]: 40000,
    [core_types_1.ChainId.OPBNB_MAINNET]: 40000,
    [core_types_1.ChainId.OPBNB_TESTNET]: 40000,
    [core_types_1.ChainId.ASTAR_MAINNET]: 40000,
    [core_types_1.ChainId.ASTAR_TESTNET]: 40000,
    [core_types_1.ChainId.CHILIZ_MAINNET]: 40000,
    [core_types_1.ChainId.CHILIZ_TESTNET]: 40000,
    [core_types_1.ChainId.CORE_MAINNET]: 40000,
    [core_types_1.ChainId.CORE_TESTNET]: 40000,
    [core_types_1.ChainId.MANTA_PACIFIC_MAINNET]: 40000,
    [core_types_1.ChainId.MANTA_PACIFIC_TESTNET]: 40000,
    [core_types_1.ChainId.CAPX_TESTNET]: 40000,
};
exports.UserOpWaitForTxHashMaxDurationIntervals = {
    [core_types_1.ChainId.MAINNET]: 20000,
    [core_types_1.ChainId.GOERLI]: 20000,
    [core_types_1.ChainId.POLYGON_MUMBAI]: 20000,
    [core_types_1.ChainId.POLYGON_MAINNET]: 20000,
    [core_types_1.ChainId.BSC_TESTNET]: 20000,
    [core_types_1.ChainId.BSC_MAINNET]: 20000,
    [core_types_1.ChainId.POLYGON_ZKEVM_TESTNET]: 20000,
    [core_types_1.ChainId.POLYGON_ZKEVM_MAINNET]: 20000,
    [core_types_1.ChainId.ARBITRUM_GOERLI_TESTNET]: 20000,
    [core_types_1.ChainId.ARBITRUM_ONE_MAINNET]: 20000,
    [core_types_1.ChainId.ARBITRUM_NOVA_MAINNET]: 20000,
    [core_types_1.ChainId.OPTIMISM_MAINNET]: 20000,
    [core_types_1.ChainId.OPTIMISM_GOERLI_TESTNET]: 20000,
    [core_types_1.ChainId.AVALANCHE_MAINNET]: 20000,
    [core_types_1.ChainId.AVALANCHE_TESTNET]: 20000,
    [core_types_1.ChainId.MOONBEAM_MAINNET]: 20000,
    [core_types_1.ChainId.BASE_GOERLI_TESTNET]: 20000,
    [core_types_1.ChainId.BASE_MAINNET]: 20000,
    [core_types_1.ChainId.LINEA_TESTNET]: 20000,
    [core_types_1.ChainId.LINEA_MAINNET]: 20000,
    [core_types_1.ChainId.MANTLE_MAINNET]: 20000,
    [core_types_1.ChainId.MANTLE_TESTNET]: 20000,
    [core_types_1.ChainId.OPBNB_MAINNET]: 20000,
    [core_types_1.ChainId.OPBNB_TESTNET]: 20000,
    [core_types_1.ChainId.ASTAR_MAINNET]: 20000,
    [core_types_1.ChainId.ASTAR_TESTNET]: 20000,
    [core_types_1.ChainId.CHILIZ_MAINNET]: 20000,
    [core_types_1.ChainId.CHILIZ_TESTNET]: 20000,
    [core_types_1.ChainId.CORE_MAINNET]: 20000,
    [core_types_1.ChainId.CORE_TESTNET]: 20000,
    [core_types_1.ChainId.MANTA_PACIFIC_MAINNET]: 20000,
    [core_types_1.ChainId.MANTA_PACIFIC_TESTNET]: 20000,
    [core_types_1.ChainId.CAPX_TESTNET]: 20000,
};
exports.DEFAULT_ENTRYPOINT_ADDRESS = "0x5ff137d4b0fdcd49dca30c7cf57e578a026d2789";
//# sourceMappingURL=Constants.js.map